import "./App.css";
import {
  MenuItem,
  FormControl,
  Select,
  Card,
  CardContent,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import Infobox from "./Infobox";
import Map from "./Map";
import Table from "./Table";
import { sortData } from "./util";
import "leaflet/dist/leaflet.css";
function App() {
  const [countries, setcountries] = useState([]);
  const [country, setCountry] = useState("worldwide");
  const [countryinfo, setcountryinfo] = useState({});
  const [TableData, setTableData] = useState([]);
  const [mapcenter, setmapcenter] = useState({ lat: 34.80746, lng: -40.4796 });
  const [mapzoom, setMapZoom] = useState(3);
  const [mapcountries, setmapcountries] = useState([]);
  const [caseType, setcasestype] = useState("cases");
  useEffect(() => {
    fetch("https://disease.sh/v3/covid-19/all")
      .then((response) => response.json())
      .then((data) => setcountryinfo(data));
  }, []);

  const oncountrychange = async (event) => {
    const countrycode = event.target.value;

    const url =
      countrycode === "worldwide"
        ? "https://disease.sh/v3/covid-19/all"
        : ` https://disease.sh/v3/covid-19/countries/${countrycode}`;
    await fetch(url)
      .then((response) => response.json())
      .then((data) => {
        setCountry(countrycode);

        setcountryinfo(data);
        setmapcenter([data.countryInfo.lat, data.countryInfo.long]);
        setMapZoom(5);
      });
  };

  console.log(countryinfo);
  useEffect(() => {
    const getCountriesData = async () => {
      await fetch(" https://disease.sh/v3/covid-19/countries")
        .then((response) => response.json())
        .then((data) => {
          const Countries = data.map((country) => ({
            name: country.country,
            value: country.countryInfo.iso2,
          }));
          const sortedData = sortData(data);
          setTableData(sortedData);
          setcountries(Countries);
          setmapcountries(data);
        });
    };
    getCountriesData();
  }, []);
  return (
    <div className="app">
      <div className="app__left">
        <div className="app__header">
          <h1>Covid-19 Tracker</h1>
          <FormControl className="app__dropdown">
            <Select
              variant="outlined"
              value={country}
              onChange={oncountrychange}
            >
              <MenuItem value="worldwide">worldwide</MenuItem>
              {countries.map((country) => (
                <MenuItem value={country.value}>{country.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div className="app__stats">
          <Infobox
            active={caseType==="cases"}
            onClick={(e) => setcasestype("cases")}
            title="coronavirus cases"
            total={`${countryinfo.cases} total`}
            cases={countryinfo.todayCases}
          ></Infobox>
          <Infobox
            active={caseType==="recovered"}
            title="recovered"
            onClick={(e) => setcasestype("recovered")}
            total={`${countryinfo.recovered} total`}
            cases={countryinfo.todayRecovered}
          ></Infobox>
          <Infobox
          active={caseType==="deaths"}
            title="deaths"
            onClick={(e) => setcasestype("deaths")}
            total={`${countryinfo.deaths} total`}
            cases={countryinfo.todayDeaths}
          ></Infobox>
        </div>
        <Map
          center={mapcenter}
          zoom={mapzoom}
          countries={mapcountries}
          casesType={caseType}
        ></Map>
      </div>
      <Card className="app__right">
        <CardContent>
          <h3>liveCases by country</h3>
          <Table countries={TableData}></Table>
          <h3>Worldwide new cases</h3>
        </CardContent>
      </Card>
    </div>
  );
}

export default App;
